import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  private readonly MOBILE_BREAKPOINT = 768;

  // largeur actuelle
  private readonly width = signal<number>(window.innerWidth);

  // signal calculé : est mobile ou non
  readonly isMobile = computed(() => this.width() < this.MOBILE_BREAKPOINT);

  constructor() {
    window.addEventListener('resize', () => {
      this.width.set(window.innerWidth);
    });
  }
}
